import PropTypes from 'prop-types';

import { Button } from '@mui/material';

import GenericFormContainer from '../../Forms/GenericFormContainer';

import {
  communityImagesLimit,
  lengthValidation255,
  lengthValidation1000,
  maxFileSize,
  required,
} from '../../Forms/utils';
import { getPostLabel } from '../utils';

import { COMMUNITY_IMAGES_LIMIT, COMMUNITY_POST_TYPES } from '../constants';

import { CHECKBOX, IMAGE_UPLOAD, STYLED_TEXT } from '../../Forms/fieldTypes';

const CommunityPostFormComponent = (props) => {
  const {
    form,
    isUpdate,
    onPostSubmit,
    initialValues,
    type,
    onModalClose,
    isFreeItem,
    imagesCount,
  } = props;

  const formData = [
    {
      keyName: 'subject',
      label: type === COMMUNITY_POST_TYPES.marketplace ? 'Item name' : 'Title',
      fieldType: STYLED_TEXT,
      validate: [required, lengthValidation255],
    },
    {
      keyName: 'price',
      label: 'Price',
      fieldType: STYLED_TEXT,
      type: 'number',
      validate: isFreeItem ? [] : [required],
      disabled: isFreeItem,
      isHidden: type !== COMMUNITY_POST_TYPES.marketplace,
    },
    {
      keyName: 'free',
      label: 'Free',
      fieldType: CHECKBOX,
      validate: [],
      isHidden: type !== COMMUNITY_POST_TYPES.marketplace,
    },
    {
      keyName: 'text',
      label: getPostLabel(type),
      fieldType: STYLED_TEXT,
      multiline: true,
      validate: [required, lengthValidation1000],
    },
    {
      keyName: 'images',
      label: 'Images',
      fieldType: IMAGE_UPLOAD,
      validate: [maxFileSize, communityImagesLimit],
      disabled: imagesCount >= COMMUNITY_IMAGES_LIMIT,
      isMulti: true,
    },
  ];

  const CancelButton = () => (
    <Button
      type="cancel"
      variant="contained"
      color="inherit"
      disableElevation
      onClick={onModalClose}
    >
      Cancel
    </Button>
  );

  return (
    <GenericFormContainer
      form={form}
      initialValues={initialValues}
      formData={formData}
      onSubmit={onPostSubmit}
      submitText={isUpdate ? 'Update' : 'Post'}
      disabled={false}
      backButton={false}
      CustomComponent={CancelButton}
      isFullWidthForm
      enableReinitialize
    />
  );
};

CommunityPostFormComponent.defaultProps = {
  initialValues: null,
};

CommunityPostFormComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onPostSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object),
  type: PropTypes.string.isRequired,
  onModalClose: PropTypes.func.isRequired,
  isFreeItem: PropTypes.bool.isRequired,
  isUpdate: PropTypes.bool.isRequired,
  imagesCount: PropTypes.number,
};

export default CommunityPostFormComponent;
